/** Account-specific display control; never retires the SDK or stops telemetry. */
export interface HoldoutDecision {id: string; status: string; arm: 'widget'|'control'|null; widget_enabled: boolean; ends_at?: string}
export function makeHoldout(
  account: () => string|null,
  request: (user: string) => Promise<HoldoutDecision|null>,
  apply: (suppressed: boolean) => void,
  beforeChange: () => void,
  observe: () => void,
  eligible: () => boolean = () => true,
) {
  let current: string|null=null, decision: HoldoutDecision|null=null, busy=false, stopped=false, generation=0;
  let suppressed=false;
  const change=(off: boolean) => { if(off!==suppressed){suppressed=off;apply(off);} };
  const expired=()=>!!decision?.ends_at && Date.now()>=Date.parse(decision.ends_at.replace(' ','T')+'Z');
  const tick=async (refresh=false): Promise<void> => {
    if(stopped)return;
    const user=account();
    if(user!==current){beforeChange();current=user;decision=null;generation++;busy=false;change(!!user);refresh=true;}
    if(expired()){beforeChange();decision=null;change(false);refresh=true;}
    if(!user || busy || (!decision && !eligible()) || (!refresh && decision))return;
    // Flush the inactive interval before the server can enroll this account.
    // While the response is in flight, measurements explicitly say pending.
    if(decision?.status==='inactive')beforeChange();
    busy=true;const version=generation;
    const result=await request(user).catch(()=>null);
    if(stopped || version!==generation || account()!==user)return;
    if(!result){busy=false;return;}
    beforeChange();decision=result;busy=false;change(result.status==='running' && !result.widget_enabled);
    if(result.status==='running' && eligible())observe();
  };
  return {tick,suppressed:()=>suppressed,
    meta:(user:string):Record<string,string>=>user===current && decision?.status==='running' && !expired()
      ? {ab_run:decision.id,ab_state:suppressed?'off':'on'}
      : (!current && !decision && !!user) || (user===current && ((!decision && suppressed) || (busy && decision?.status==='inactive'))) ? {ab_run:'parikara-ab-v1',ab_state:'pending'} : {},
    stop:()=>{stopped=true;generation++;},
  };
}
